// Utilitários partilhados de formatação (export, PDF, etc.)

/**
 * Escapa HTML para prevenir injecção quando concatenamos strings em templates.
 * Uso típico: produzir HTML para impressão/export sem permitir XSS via dados.
 */
export const escapeHtml = (text) => {
  if (text === null || text === undefined) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/** Formata um ISO datetime em "DD/MM HH:MM" no locale pt-PT. Retorna "—" se inválido. */
export const formatHoraExport = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-PT', {
      day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
    });
  } catch (_) {
    return '—';
  }
};

/** Formata segundos em "Xh Ym" ou "Y min". Retorna "—" se vazio/zero. */
export const formatDuracaoExport = (seg) => {
  if (!seg || seg <= 0) return '—';
  const h = Math.floor(seg / 3600);
  const m = Math.floor((seg % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m} min`;
};
